module.exports = __webpack_public_path__ + "static/media/IlustracionInicial.d3733c7f.svg";